const hashStringToNumber = (str: string): number => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0 // Convert to 32-bit integer
  }
  return Math.abs(hash) // Ensure it's positive
}

export const getViews = (characterId: string, startDate: string): string => {
  const globalMinIncrement: number = 50 // Minimum daily increase
  const globalMaxIncrement: number = 150 // Maximum daily increase

  const start = new Date(startDate) // Starting date
  const today = new Date() // Current date

  // Calculate the number of days since the starting date
  const daysElapsed = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  if (daysElapsed < 0) return '0' // If the date is before the start, return 0 views

  // Generate a deterministic hash-based starting value
  const hash = hashStringToNumber(characterId)

  // Spread the starting views across a larger range (e.g., 1000 to 10000)
  const baseViews = (hash % 9000) + 1000

  // Create per-character variability in daily increments
  const minIncrement = globalMinIncrement + (hash % 50) // Add up to 50 to the global min
  const maxIncrement = globalMaxIncrement + (hash % 100) // Add up to 100 to the global max

  // Calculate total views with unique daily increment range
  const totalViews = baseViews + daysElapsed * ((minIncrement + maxIncrement) / 2)

  // Abbreviate the number for output
  return abbreviateNumber(totalViews)
}

export const abbreviateNumber = (num: number): string => {
  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(1).replace(/\.0$/, '')}k`
  }
  return num.toString()
}

// Function to generate a deterministic base number of likes
export const getBaseLikes = (characterId: string): number => {
  const minLikes = 1000 // Minimum number of likes
  const maxLikes = 5000 // Maximum number of likes

  const hash = hashStringToNumber(characterId)

  // Scale the hash value to the desired range
  return (hash % (maxLikes - minLikes + 1)) + minLikes
}

export const getModelUrl = (categorySlug?: string, modelId?: string) => {
  if (!categorySlug || !modelId) return ''
  return `/model/${categorySlug}/${modelId}`
}
